import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { STORE_PATH } from '@/shared/config';
import { buttonVariants, cn } from '@/shared/ui';

/** 저장한 디자인이 없을 때 — 스토어에서 상품을 골라 커스터마이징을 시작하게 이끈다. */
export const MyDesignEmpty = (): ReactElement => (
  <div className="flex flex-col items-center gap-5 border-y border-foreground/10 px-5 py-20 text-center sm:py-24">
    <p
      aria-hidden
      className="flex items-center gap-2 text-[11px] leading-none font-semibold tracking-[0.18em] text-muted-foreground uppercase"
    >
      <span className="block h-px w-6 bg-brand-lime" />
      No designs yet
    </p>
    <div className="space-y-2">
      <p className="text-xl font-bold tracking-[-0.02em] sm:text-2xl">
        아직 저장한 디자인이 없어요
      </p>
      <p className="text-sm text-muted-foreground">
        스토어에서 상품을 고르고 커스터마이징한 디자인을 저장하면 여기에 모입니다.
      </p>
    </div>
    <Link to={STORE_PATH} className={cn(buttonVariants({ size: 'lg' }), 'mt-2 h-12 px-8')}>
      스토어 둘러보기
    </Link>
  </div>
);
